__webpack_require__.p = "/RubiksMaster/";